import {useState, useEffect} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {useNavigate, useParams, useLocation} from 'react-router-dom';
import Breadcrumbs from '../Components/Breadcrumbs';
import { CustomCodeEditor } from '../Components/CustomFormElements';
import Button from '../Components/Buttons';
import {AlertProvider, useAlert} from '../Components/AlertContext';
import {ConfirmationProvider, useConfirmation} from '../Components/ConfirmationContext';
import {ChannelApiProvider, useChannelApi} from '../Services/ChannelApiProvider';
import PageLoader from '../Components/PageLoader';
import './Channel.css';
import {isEmpty} from '../utils/validationUtil';
import ChannelSettings from "../Components/ChannelSettings";
import TriggersList from "../Components/TriggersList";
import GuardrailsList from "../Components/GuardrailsList";
import CONFIG from "../Services/CONFIG";
import {MetaApiProvider, useMetaApi} from "../Services/MetaApiProvider";
import {useFacebookSignup} from "../Services/FacebookSignup";

function ChannelContent({canEdit}) {
    const navigate = useNavigate();
    const location = useLocation();
    const {organizationId, channelId} = useParams();
    const {showAlert} = useAlert();
    const {showConfirmation} = useConfirmation();

    const {getChannelById, getAssistants, getAssistantByChannelId, getChannelSecretsById, createChannel, updateChannel} = useChannelApi();
    const {getInstagramConstants, isConnected, getUserData, postDisconnect} = useMetaApi();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showEmbedding, setShowEmbedding] = useState(false);
    const [activeTab, setActiveTab] = useState('settings');

    const [isNew, setIsNew] = useState(true);
    const [isDisabled, setIsDisabled] = useState(true);
    const [name, setName] = useState();
    const [agent, setAgent] = useState();
    const [language, setLanguage] = useState('ukrainian');
    const [channelType, setChannelType] = useState('IFRAME');
    const [onSiteOrigin, setOnSiteOrigin] = useState();
    const [greetingMessage, setGreetingMessage] = useState();
    const [isModerated, setIsModerated] = useState(false);
    const [isAiAssistant, setIsAiAssistant] = useState(false);
    const [isAudioAllowed, setIsAudioAllowed] = useState(false);
    const [isImageAllowed, setIsImageAllowed] = useState(false);
    const [isFileAllowed, setIsFileAllowed] = useState(false)
    const [isNameRequired, setIsNameRequired] = useState(false);
    const [isPhoneField, setIsPhoneField] = useState(false);
    const [phoneMandatory, setPhoneMandatory] = useState(false);
    const [isFolded, setIsFolded] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [chatPrimaryColor, setChatPrimaryColor] = useState('#4f46e5ff');
    const [chatSecondaryColor, setChatSecondaryColor] = useState('#f9ce69ff');
    const [responseDelay, setResponseDelay] = useState(20);
    const [firstMessageDelay, setFirstMessageDelay] = useState(20);
    const [useContextThematics, setUseContextThematics] = useState(false);
    const [channelSecrets, setChannelSecrets] = useState({});
    const [zendeskDomain, setZendeskDomain] = useState();
    const [zendeskAiSubType, setZendeskAiSubType] = useState(false);
    const [zendeskAssistantFieldName, setZendeskAssistantFieldName] = useState("Sure - AI");
    const [zendeskThemeFieldName, setZendeskThemeFieldName] = useState("Sure - AI Theme");
    const [zendeskType, setZendeskType] = useState();
    const [zendeskPostType, setZendeskPostType] = useState();
    const [zendeskCommentType, setZendeskCommentType] = useState();
    const [anonymizeEntities, setAnonymizeEntities] = useState()
    const [embeddingUrl, setEmbeddingUrl] = useState()
    const [zendeskWebhookUrl, setZendeskWebhookUrl] = useState()
    const [metaUsername, setMetaUsername] = useState(null);

    const [textFields, setTextFields] = useState({
      text_request: "",
      text_success: "",
      text_confirm: "",
      text_cancel: "",
      text_failure: "",
      text_response_on_decline: ""
    });



    const [agents, setAgents] = useState([]);

    const [mainColor, setMainColor] = useState('#4f46e5');
    const [secondaryColor, setSecondaryColor] = useState('#f9ce69');

    // New First Screen + Texts + Chat Type
    const [isFirstScreenEnabled, setIsFirstScreenEnabled] = useState(true); // active by default
    const [firstLineText, setFirstLineText] = useState("Вітаю👋");
    const [secondLineText, setSecondLineText] = useState("Як можу тобі допомогти?");
    const [askBoxFirstLine, setAskBoxFirstLine] = useState("Чат");
    const [askBoxSecondLine, setAskBoxSecondLine] = useState("Задати питання");
    const [askBoxThirdLine, setAskBoxThirdLine] = useState("ШІ асистент та команда допоможуть");
    const [chatType, setChatType] = useState("widget"); // default to Widget


    // Assistant Images
    const [AIassistantImage, setAIassistantImage] = useState();
    const [liveAssistantImage, setLiveAssistantImage] = useState();
    const [liveAssistantIcon, setLiveAssistantIcon] = useState();

    const [embedUrl, setEmbedUrl] = useState("");

    const { launchSignup } = useFacebookSignup();

    useEffect(() => {
      const fetchConstants = async () => {
        try {
          if (!isConnected) {
            const response = await getInstagramConstants();
            console.log("constants:",  response);
            setEmbedUrl(response.instagram_embed_url);
            localStorage.setItem("channelId", channelId);
          }
        } catch (error) {
            console.error("Error fetching Instagram constants:", error);
        }
      };

    fetchConstants();
  }, [isConnected]);

    useEffect(() => {
      if (!isConnected) return;

      const fetchUsername = async () => {
        try {
          const response = await getUserData();

          if (response?.username) {
            setMetaUsername(response.username);
          }
        } catch (error) {
          console.error("Error fetching Instagram user data:", error);
        }
      };

      fetchUsername();
    }, [isConnected])


    const updateSecrets = (newSecrets) => {
        setChannelSecrets((prevSecrets) => ({
            ...prevSecrets,
            ...newSecrets,
        }));
    };

    useEffect(() => {
      const handleAlert = async () => {
        const alertState = location.state;
        console.log("Alert state:", alertState);

        if (alertState?.message) {
          await showAlert(alertState.type, alertState.message);

          navigate(location.pathname, { replace: true, state: {} });
        }
      };

      handleAlert();
    }, [location.state, navigate]);

    useEffect(() => {
        const f = async () => {
            setLoading(true);

            try {
                const assistants = await getAssistants();
                setAgents(assistants);

                if (channelId === "new-channel") {
                    return;
                }

                const channel = await getChannelById(channelId);
                // console.log('channel - ',channel.ai_assistant_image_artifact_key);
                const assistant = await getAssistantByChannelId(channelId);
                const secrets = await getChannelSecretsById(channelId);
                setChannelSecrets(secrets);
                setName(channel.name);
                setAgent(assistant.key);
                setResponseDelay(channel.response_delay);
                setFirstMessageDelay(channel.first_message_delay);
                setUseContextThematics(channel.use_context_thematics);
                setLanguage(channel.language);

                setChannelType(channel.channel_type);
                setOnSiteOrigin(channel.on_site_origin);
                setGreetingMessage(channel.greeting_message);
                setIsModerated(channel.is_moderated);
                setIsAiAssistant(channel.is_assistant_enabled);
                setIsAudioAllowed(channel.is_audio_enabled);
                setIsImageAllowed(channel.is_image_enabled);
                setIsFileAllowed(channel.is_file_enabled);
                setIsNameRequired(channel.request_name);
                setIsFolded(channel.is_folded);
                setIsActive(channel.is_active);
                setChatPrimaryColor(channel.chat_primary_color);
                setChatSecondaryColor(channel.chat_secondary_color);
                // setEmbeddingUrl(`http://localhost:3001/${channel.id}/`);
                setEmbeddingUrl(channel.embedding_url);
                setZendeskWebhookUrl(channel.zendesk_webhook_url);
                setZendeskDomain(channel.zendesk_domain);
                setZendeskAiSubType(channel.zendesk_add_ai_subtype || false);
                setZendeskAssistantFieldName(channel.zendesk_assistant_field_name || "");
                setZendeskThemeFieldName(channel.zendesk_theme_field_name || "");
                setZendeskType(channel.zendesk_type);
                setZendeskPostType(channel.zendesk_post_type);
                setZendeskCommentType(channel.zendesk_comment_type);

                setIsPhoneField(channel.request_phone);
                setPhoneMandatory(channel.require_phone);
                setAnonymizeEntities(channel.anonymize_entities)

                // First screen settings
                setIsFirstScreenEnabled(
                    typeof channel.show_first_screen === 'boolean' ? channel.show_first_screen : true
                );
                setFirstLineText(channel.first_line_text || "Вітаю👋");
                setSecondLineText(channel.second_line_text || "Як можу тобі допомогти?");
                setAskBoxFirstLine(channel.ask_box_first_line || "Чат");
                setAskBoxSecondLine(channel.ask_box_second_line || "Задати питання");
                setAskBoxThirdLine(channel.ask_box_third_line || "ШІ асистент та команда допоможуть");
                setChatType(channel.chat_type || "widget");

                // Assistant images
                setAIassistantImage(channel.ai_assistant_image_artifact_key || undefined);
                // console.log('channel settings - ',channel);
                setLiveAssistantImage(channel.live_assistant_image_artifact_key || undefined);
                setLiveAssistantIcon(channel.live_assistant_icon || undefined);

                setMainColor(channel.main_color || '#4f46e5');
                setSecondaryColor(channel.secondary_color || '#f9ce69');

                setTextFields(channel.text_fields || {});
            } catch (error) {
                setError('Error fetching channel data');
                console.error('Error fetching channel data:', error);
            } finally {
                setLoading(false);
            }
        };
        f();
    }, [channelId]);

    
    
    useEffect(() => {
        setIsNew(channelId === 'new-channel');
        setIsDisabled(!canEdit);
    }, [channelId])

    useEffect(() => {
        if (!isPhoneField && phoneMandatory) {
            setPhoneMandatory(false);
        }
    }, [isPhoneField, phoneMandatory]);

    const onCancel = () => {
        navigate(`/organizations/${organizationId}/channels`);
    };

    const onOpenEmbedding = () => {
        setShowEmbedding(true);
    }

    const onSave = () => {
        if (isEmpty(name)) {
            showAlert("fail", "Channel name is required");
            return;
        }

        if (isEmpty(agent)) {
            showAlert("fail", "Agent is required");
            return;
        }

        if (isEmpty(language)) {
            showAlert("fail", "Language is required");
            return;
        }

        if (isEmpty(channelType)) {
            showAlert("fail", "Channel type is required");
            return;
        }

        if (channelType === 'IFRAME' && isEmpty(onSiteOrigin)) {
            showAlert("fail", "On-site origin is required");
            return;
        }

        if (channelType === 'TELEGRAM' && isEmpty(channelSecrets?.telegram_token)) {
            showAlert("fail", "Telegram token is required");
            return;
        }

        if (channelType === 'ZENDESK') {
            if (isEmpty(zendeskDomain)) {
                showAlert("fail", "Zendesk domain is required");
                return;
            }
        }

        if (
          isPhoneField &&
          Object.values(textFields).some(isEmpty)
        ) {
          showAlert(
            "fail",
            "Text request, Text success, Text confirm, Text cancel, Text failure, and Text response on decline fields are required"
          );
          return;
        }

        let channel = {
            name,
            assistant_key: agent,
            language,
            channel_type: channelType,
            on_site_origin: onSiteOrigin,
            greeting_message: greetingMessage,
            is_moderated: isModerated,
            is_assistant_enabled: isAiAssistant,
            is_audio_enabled: isAudioAllowed,
            is_image_enabled: isImageAllowed,
            is_file_enabled: isFileAllowed,
            request_name: isNameRequired,
            request_phone: isPhoneField,
            require_phone: phoneMandatory,
            is_folded: isFolded,
            is_active: isActive,
            chat_primary_color: chatPrimaryColor,
            chat_secondary_color: chatSecondaryColor,
            response_delay: responseDelay,
            first_message_delay: firstMessageDelay,
            use_context_thematics: useContextThematics,
            embedding_url: embeddingUrl,
            zendesk_domain: zendeskDomain,
            zendesk_add_ai_subtype: zendeskAiSubType,
            zendesk_assistant_field_name: zendeskAssistantFieldName,
            zendesk_theme_field_name: zendeskThemeFieldName,
            zendesk_type: zendeskType,
            zendesk_post_type: zendeskPostType,
            zendesk_comment_type: zendeskCommentType,
            main_color: mainColor,
            secondary_color: secondaryColor,
            anonymize_entities: anonymizeEntities,

            // First screen settings
            show_first_screen: isFirstScreenEnabled,
            first_line_text: firstLineText,
            second_line_text: secondLineText,
            ask_box_first_line: askBoxFirstLine,
            ask_box_second_line: askBoxSecondLine,
            ask_box_third_line: askBoxThirdLine,
            chat_type: chatType,

            // Images management
            ai_assistant_image: AIassistantImage,
            live_assistant_image: liveAssistantImage,
            live_assistant_icon: liveAssistantIcon,

            text_fields: textFields,
        };
        channel = {
            ...channel,
            ...channelSecrets
        };

        if (channelId === "new-channel") {
            showConfirmation(
                `Are you sure you want to create a new channel?`,
                async () => {
                    try {
                        setLoading(true);
                        const result = await createChannel(channel);
                        console.log("Channel created successfully:", result);
                        showAlert('success', 'Channel created successfully');
                        navigate(`/organizations/${organizationId}/channels/${result.id}`);
                    } catch (error) {
                        showAlert('fail', 'Failed to create channel');
                    } finally {
                        setLoading(false);
                    }
                }
            )
        } else {
            showConfirmation(
                `Are you sure you want to save the changes?`,
                async () => {
                    try {
                        setLoading(true);
                        await updateChannel(channelId, channel);
                        showAlert('success', 'Channel updated successfully');
                        // navigate(`/organizations/${organizationId}/channels`);
                    } catch (error) {
                        showAlert('fail', error?.response?.data?.error || 'Failed to update channel');
                    } finally {
                        setLoading(false);
                    }
                }
            )
        }
    };

    const disconnect = async () => {
        showConfirmation(
            `Are you sure you want to disconnect your account?`,
            async () => {
                try {
                    setLoading(true);
                    await postDisconnect(channelId);
                    showAlert('success', 'Your account disconnected successfully');
                } catch (error) {
                    showAlert('fail', 'Failed to disconnect your account');
                } finally {
                    setLoading(false);
                }
            }
        );
    };


    if (loading) {
        return <PageLoader/>;
    }

    const onChangeActiveTab = () => {
        const nextTab = activeTab === 'settings' ? 'trigger' : 'settings';
        setActiveTab(nextTab);
    }

    return (
        <div className="container">
            <Breadcrumbs/>
            <div className="row d-flex gap">
                <div className="radius-yes p-2 bg-yes col-6">
                    <div className='d-flex justify-between align-center'>
                        <h2 className='h2-title m-0'>{name}</h2>
                        {!isNew && (
                            <div className='buttons-container d-flex justify-end gap-2'>
                                <Button 
                                    variant={activeTab === 'trigger' ? 'primary' : 'secondary'} 
                                    size='large' 
                                    onClick={() => setActiveTab(activeTab === 'trigger' ? 'settings' : 'trigger')}
                                >
                                    {activeTab === 'trigger' ? 'View Settings' : 'View Triggers'}
                                </Button>
                                <Button 
                                    variant={activeTab === 'guardrails' ? 'primary' : 'secondary'} 
                                    size='large' 
                                    onClick={() => setActiveTab(activeTab === 'guardrails' ? 'settings' : 'guardrails')}
                                >
                                    {activeTab === 'guardrails' ? 'View Settings' : 'View Guardrails'}
                                </Button>
                            </div>
                        )}
                    </div>
                    <div className='gap d-flex flex-row-to-col flex-column'>
                        {(activeTab === 'settings' || isNew) && (
                        <ChannelSettings
                            name={name}
                            setName={setName}
                            agent={agent}
                            setAgent={setAgent}
                            language={language}
                            setLanguage={setLanguage}
                            channelType={channelType}
                            setChannelType={setChannelType}
                            onSiteOrigin={onSiteOrigin}
                            setOnSiteOrigin={setOnSiteOrigin}
                            greetingMessage={greetingMessage}
                            setGreetingMessage={setGreetingMessage}
                            isModerated={isModerated}
                            setIsModerated={setIsModerated}
                            isAudioAllowed={isAudioAllowed}
                            setIsAudioAllowed={setIsAudioAllowed}
                            isImageAllowed={isImageAllowed}
                            setIsImageAllowed={setIsImageAllowed}
                            setIsFileAllowed={setIsFileAllowed}
                            isFileAllowed={isFileAllowed}
                            isNameRequired={isNameRequired}
                            setIsNameRequired={setIsNameRequired}
                            isPhoneField={isPhoneField}
                            setPhone={setIsPhoneField}
                            phoneMandatory={phoneMandatory}
                            setPhoneMandatory={setPhoneMandatory}
                            isFolded={isFolded}
                            setIsFolded={setIsFolded}
                            isActive={isActive}
                            setIsActive={setIsActive}
                            chatPrimaryColor={chatPrimaryColor}
                            setChatPrimaryColor={setChatPrimaryColor}
                            chatSecondaryColor={chatSecondaryColor}
                            setChatSecondaryColor={setChatSecondaryColor}
                            responseDelay={responseDelay}
                            setResponseDelay={setResponseDelay}
                            agents={agents}
                            isDisabled={isDisabled}
                            isNew={isNew}
                            secrets={channelSecrets}
                            setSecrets={updateSecrets}
                            zendeskDomain={zendeskDomain}
                            setZendeskDomain={setZendeskDomain}
                            zendeskAiSubType={zendeskAiSubType}
                            setZendeskAiSubType={setZendeskAiSubType}
                            zendeskAssistantFieldName={zendeskAssistantFieldName}
                            setZendeskAssistantFieldName={setZendeskAssistantFieldName}
                            zendeskType={zendeskType}
                            setZendeskType={setZendeskType}
                            zendeskPostType={zendeskPostType}
                            setZendeskPostType={setZendeskPostType}
                            zendeskCommentType={zendeskCommentType}
                            setZendeskCommentType={setZendeskCommentType}
                            zendeskThemeFieldName={zendeskThemeFieldName}
                            setZendeskThemeFieldName={setZendeskThemeFieldName}
                            mainColor={mainColor}
                            setMainColor={setMainColor}
                            secondaryColor={secondaryColor}
                            setSecondaryColor={setSecondaryColor}
                            anonymizeEntities={anonymizeEntities}
                            setAnonymizeEntities={setAnonymizeEntities}
                            embedUrl={embedUrl}
                            isConnected={isConnected}
                            metaUsername={metaUsername}
                            disconnect={disconnect}

                            // First screen settings
                            isFirstScreenEnabled={isFirstScreenEnabled}
                            setIsFirstScreenEnabled={setIsFirstScreenEnabled}
                            firstLineText={firstLineText}
                            setFirstLineText={setFirstLineText}
                            secondLineText={secondLineText}
                            setSecondLineText={setSecondLineText}
                            askBoxFirstLine={askBoxFirstLine}
                            setAskBoxFirstLine={setAskBoxFirstLine}
                            askBoxSecondLine={askBoxSecondLine}
                            setAskBoxSecondLine={setAskBoxSecondLine}
                            askBoxThirdLine={askBoxThirdLine}
                            setAskBoxThirdLine={setAskBoxThirdLine}
                            chatType={chatType}
                            setChatType={setChatType}

                            // Assistant Images
                            AIassistantImage={AIassistantImage}
                            setAIassistantImage={setAIassistantImage}
                            liveAssistantImage={liveAssistantImage}
                            setLiveAssistantImage={setLiveAssistantImage}
                            liveAssistantIcon={liveAssistantIcon}
                            setLiveAssistantIcon={setLiveAssistantIcon}
                            isAiAssistant={isAiAssistant}
                            setIsAiAssistant={setIsAiAssistant}
                            firstMessageDelay={firstMessageDelay}
                            setFirstMessageDelay={setFirstMessageDelay}
                            useContextThematics={useContextThematics}
                            setUseContextThematics={setUseContextThematics}
                            launchSignup={launchSignup}
                            textFields={textFields}
                            setTextFields={setTextFields}
                        />
                        )}

                        {activeTab === 'trigger' && !isNew && (
                            <div className='int-col-3 p-2 border-yes radius-yes full-width-on-sml-scr'>
                                <TriggersList
                                    channelId={channelId}
                                    canEdit={!isDisabled}
                                    loading={loading}
                                />

                            </div>
                        )}
                        {activeTab === 'guardrails' && !isNew && (
                            <div className='int-col-3 p-2 border-yes radius-yes full-width-on-sml-scr'>
                                <GuardrailsList
                                    channelId={channelId}
                                    canEdit={!isDisabled}
                                    loading={loading}
                                />
                            </div>
                        )}
                        {activeTab === 'settings' && (
                            <div className='buttons-container d-flex justify-end'>
                                <Button variant='primary' size='medium' disabled={isDisabled} onClick={onSave}>
                                    Save
                                </Button>
                                <Button variant='danger' size='medium' onClick={onCancel}>
                                    Cancel
                                </Button>
                            </div>
                        )}

                    </div>
                </div>

                {showEmbedding && (
                    <AnimatePresence>
                        <motion.div
                            className="confirmation-popup-overlay"
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: 0.3}}
                        >
                            <motion.div
                                className="confirmation-popup"
                                style={{padding: '35px', width: '380px'}}
                                initial={{scale: 0.8}}
                                animate={{scale: 1}}
                                exit={{scale: 0.8}}
                                transition={{duration: 0.3}}
                            >
                                <Button variant='close' size='round' onClick={() => setShowEmbedding(false)}></Button>
                                <iframe
                                    src={embeddingUrl}
                                    style={{width: '100%', height: '788px', border: 'none', borderRadius: '16px'}}
                                    allow="microphone; camera"
                                ></iframe>
                            </motion.div>
                        </motion.div>
                    </AnimatePresence>
                )}

                {channelType === "ZENDESK" && isNew === false && (
                    <>
                         <div className="radius-yes p-2 bg-yes col-3">
                            {zendeskType === "TICKET" &&(
                                <>
                                    <h2 className='h2-title'>Zendesk Ticket Webhook URL</h2>
                                    <CustomCodeEditor
                                        id="z-webhook-url"
                                        value={`${zendeskWebhookUrl}/v1/channels/${channelId}/tickets/webhook`}
                                        boxtitle=''
                                        wrapText={true}
                                        language="javascript"
                                        editable={false}
                                        height='100px'
                                        highlightActiveLine={false}
                                        lightTheme='githubLight'
                                        darkTheme='dracula'
                                        lineNumbers={false}
                                        foldGutter={false}
                                    />
                                </>
                            )}
                            {zendeskType === "CONVERSATION" && (
                                <>
                                    <h2 className='h2-title'>Zendesk Conversation Webhook URL</h2>
                                    <CustomCodeEditor
                                        id="z-webhook-url"
                                        value={`${zendeskWebhookUrl}/v1/channels/${channelId}/conversations/webhook`}
                                        boxtitle=''
                                        wrapText={true}
                                        language="javascript"
                                        editable={false}
                                        height='auto'
                                        highlightActiveLine={false}
                                        lightTheme='githubLight'
                                        darkTheme='dracula'
                                        lineNumbers={false}
                                        foldGutter={false}
                                    />
                                </>
                            )}
                            {zendeskType === "TRIGGER" && (
                                <>
                                    <h2 className='h2-title'>Zendesk Trigger Webhook URL</h2>
                                    <CustomCodeEditor
                                        id="z-webhook-url"
                                        value={`${zendeskWebhookUrl}/v1/channels/${channelId}/triggers/webhook`}
                                        boxtitle=''
                                        wrapText={true}
                                        language="javascript"
                                        editable={false}
                                        height='auto'
                                        highlightActiveLine={false}
                                        lightTheme='githubLight'
                                        darkTheme='dracula'
                                        lineNumbers={false}
                                        foldGutter={false}
                                    />
                                    <h2 className='h2-title'>Zendesk Trigger Action</h2>
                                    <CustomCodeEditor
                                        id="z-webhook-url"
                                        value={`{
	"type": "sure:ticket_comment_added:v1",
	"ticket_id": "{{ticket.id}}",
	"ticket_status": "{{ticket.status}}",
	"ticket_updated_at": "{{ticket.updated_at_with_timestamp}}",
	"comment_id":  "{{ticket.latest_comment.id}}",
	"comment":  "{{ticket.latest_comment}}",
	"author_role":  "{{ticket.latest_comment.author.role}}",
	"attachments": [
		{% for attachment in ticket.latest_comment.attachments %}
		{
			"filename": "{{attachment.filename}}", 
			"url": "{{attachment.url}}"
		}
		{% unless forloop.last %},{% endunless %}{% endfor %}
	]
}`}
                                        boxtitle=''
                                        wrapText={true}
                                        language="javascript"
                                        editable={false}
                                        height='auto'
                                        highlightActiveLine={false}
                                        lightTheme='githubLight'
                                        darkTheme='dracula'
                                    />
                                </>
                            )}
                            
                            <h2 className='h2-title'>Workspace App URL</h2>
                            <CustomCodeEditor
                                id="z-webhook-url"
                                value={`${zendeskWebhookUrl}/v1/channels/${channelId}/workspace`}
                                boxtitle=''
                                wrapText={true}
                                language="javascript"
                                editable={false}
                                height='auto'
                                highlightActiveLine={false}
                                lightTheme='githubLight'
                                darkTheme='dracula'
                                lineNumbers={false}
                                foldGutter={false}
                            />
                         </div>
                    </>
                )}

                {channelType === "IFRAME" && isNew === false && (
                    <div className="iframe-container radius-yes p-2 bg-yes col-3">
                        <h2 className='h2-title'>Iframe embedding code</h2>
                        <CustomCodeEditor
                            id="code-editor-1"
                            value={
  chatType === 'static-box'
    ? `<!-------------------- STATIC CHAT BOX EMBED CODE ------------------------->
<iframe id="sureChat"
  src="${embeddingUrl}"
  style="
    width: 100%; 
    height: 788px; 
    border:none; 
    border-radius:12px; 
    z-index:9999;
    backdrop-filter: blur(150px);
    box-shadow: 25px 0px 45px 0px #0000004D;
"
  sandbox="
        allow-scripts 
        allow-same-origin 
        allow-forms 
        allow-popups 
        allow-popups-to-escape-sandbox
        allow-popups-to-escape-sandbox
        allow-storage-access-by-user-activation
        "
  allow="clipboard-write; microphone; fullscreen; storage-access">
</iframe>
<style>
  /* Locks page scroll while chat is fullscreen */
  .no-scroll { overflow: hidden; height: 100vh; }

  /* Fullscreen overlay for static-box */
  .chat-static-fullscreen {
    position: fixed !important;
    inset: 0 !important;            /* top/right/bottom/left = 0 */
    width: 100svw !important;       /* safe viewport width */
    height: 100dvh !important;      /* dynamic viewport height */
    border-radius: 0 !important;
    z-index: 99999 !important;
    background: transparent;
  }
</style>
<script>
  const iframe = document.getElementById('sureChat');

  function setFullscreen(on) {
    if (on) {
      iframe.classList.add('chat-static-fullscreen');
      document.documentElement.classList.add('no-scroll');
    } else {
      iframe.classList.remove('chat-static-fullscreen');
      document.documentElement.classList.remove('no-scroll');
      // restore inline size
      iframe.style.width = '100%';
      iframe.style.height = '788px';
      iframe.style.borderRadius = '12px';
    }
  }

  // Handshake: tell iframe the parent is ready (sent TO iframe origin)
    function getIframeOrigin(iframe) {
        try { return new URL(iframe.src).origin; } catch { return null; }
    }

    function sendParentReady(iframe) {
        const origin = getIframeOrigin(iframe);
        if (!origin) return;

        try {
        iframe.contentWindow?.postMessage({ type: 'sure_parent_ready' }, origin);
        } catch (e) {
        console.warn('[PARENT] sure_parent_ready postMessage failed:', e);
        }
    }

    (function initHandshake() {
        if (!iframe) return;

        iframe.addEventListener('load', () => {
        sendParentReady(iframe);

        // optional: re-send a couple of times
        let n = 0;
        const t = setInterval(() => {
            n++;
            sendParentReady(iframe);
            if (n >= 3) clearInterval(t);
        }, 400);
        }, { once: true });

        // Best-effort in case load already fired very fast
        setTimeout(() => sendParentReady(iframe), 300);
    })();

      window.addEventListener('message', (event) => {
        if (!iframe) return;

        const iframeOrigin = getIframeOrigin(iframe);
        if (iframeOrigin && event.origin !== iframeOrigin) return;

        // Always keep resize working (but only from iframe origin)
        if (event.data?.type === 'resizeChatIframe') {
        const { fullscreen, height, mode } = event.data.payload || {};
        if (mode === 'static-box') {
            setFullscreen(Boolean(fullscreen));
            if (!fullscreen && typeof height === 'number') {
            iframe.style.height = \`\${height}px\`;
            }
        }
        return;
        }

        // GTM relay
        if (event.data?.type === 'sure_message_posted') {
        const msg = event.data.payload || {};
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'sure_message_posted',
            chatId: msg.chatId || '',
            message_id: msg.id || '',
            text_length: msg.text_length ?? (typeof msg.text === 'string' ? msg.text.length : 0),
            timestamp: msg.timestamp || ''
        });
        }
    });

</script>
<!-------------------- END OF STATIC CHAT BOX EMBED CODE ------------------------->`
: `<!-------------------- WIDGET CHAT BOX EMBED CODE ------------------------->
<iframe id="sureChat" src="${embeddingUrl}"
  style="
    width: 380px;
    /* Max 788px, otherwise fit the visible viewport minus 20px bottom + 20px headroom */
    height: min(788px, calc(100dvh - 40px));
    max-height: 788px;
    border: none;
    position: fixed;
    bottom: 20px;
    right: 20px;
    border-radius: 12px;
    z-index: 9999999999999;
  "
  sandbox="
  allow-scripts
  allow-same-origin
  allow-forms
  allow-popups
  allow-popups-to-escape-sandbox
  allow-storage-access-by-user-activation
  "
  allow="clipboard-write; microphone; fullscreen; storage-access"></iframe>
<style>
  .chat-fullscreen {
    position: fixed !important;
    inset: 0 !important;
    width: 100svw !important;
    height: 100dvh !important;
    border-radius: 0 !important;
  }
</style>
<script>
  const MAX_H = 788;   // px
  const MARGINS = 40;  // 20px bottom + 20px headroom

  function applyResponsiveHeight(iframe) {
    iframe.style.height = 'min(' + MAX_H + 'px, calc(100dvh - ' + MARGINS + 'px))';
  }

   function getIframe() {
    return document.getElementById('sureChat');
  }

  // Initial responsive height + keep it synced on viewport changes
  (function rebalance() {
    const i = getIframe();
    if (i && !i.classList.contains('chat-fullscreen')) applyResponsiveHeight(i);
  })();
  window.addEventListener('resize', function(){ const i = getIframe(); if (i && !i.classList.contains('chat-fullscreen')) applyResponsiveHeight(i); });
  window.addEventListener('orientationchange', function(){ const i = getIframe(); if (i && !i.classList.contains('chat-fullscreen')) applyResponsiveHeight(i); });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function(){ const i = getIframe(); if (i && !i.classList.contains('chat-fullscreen')) applyResponsiveHeight(i); });

  function getIframeOrigin(iframe) {
  try { return new URL(iframe.src).origin; } catch { return null; }
}

// ---------- HANDSHAKE (send after iframe is really loaded) ----------
  function sendParentReady(iframe) {
    const origin = getIframeOrigin(iframe);
    if (!origin) return;

    try {
      iframe.contentWindow?.postMessage({ type: 'sure_parent_ready' }, origin);
    } catch (e) {
      console.warn('[PARENT] sure_parent_ready postMessage failed:', e);
    }
  }

  (function initHandshake() {
    const iframe = getIframe();
    if (!iframe) return;

    iframe.addEventListener('load', () => {
      sendParentReady(iframe);

      let n = 0;
      const t = setInterval(() => {
        n++;
        sendParentReady(iframe);
        if (n >= 3) clearInterval(t);
      }, 400);
    }, { once: true });

    setTimeout(() => sendParentReady(iframe), 300);
  })();

window.addEventListener('message', (event) => {
  const iframe = getIframe();
  if (!iframe) return;

  const iframeOrigin = getIframeOrigin(iframe);
  if (iframeOrigin && event.origin !== iframeOrigin) return;

  // 1) Resize logic (unchanged)
  if (event.data && event.data.type === 'resizeChatIframe') {
    const payload = event.data.payload || {};
    const width = payload.width;
    const fullscreen = payload.fullscreen;

    if (fullscreen) {
      iframe.classList.add('chat-fullscreen');
      iframe.style.width = '100svw';
      iframe.style.height = '100dvh';
      iframe.style.borderRadius = '0';
      iframe.style.bottom = '';
      iframe.style.right = '';
    } else {
      iframe.classList.remove('chat-fullscreen');
      iframe.style.width = (typeof width === 'number') ? (width + 'px') : '380px';
      applyResponsiveHeight(iframe);
      iframe.style.borderRadius = '12px';
      iframe.style.bottom = '20px';
      iframe.style.right = '20px';
    }
    return;
  }

  // 2) GTM event relay
  if (event.data && event.data.type === 'sure_message_posted') {
    const msg = event.data.payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'sure_message_posted',
      chatId: msg.chatId || '',
      message_id: msg.id || '',
      text_length: msg.text_length ?? (typeof msg.text === 'string' ? msg.text.length : 0),
      timestamp: msg.timestamp || ''
    });
  }
});
</script>
<!-------------------- WIDGET CHAT BOX EMBED CODE ------------------------->`
}
                            boxtitle='HTML'
                            wrapText={true}
                            language="javascript"
                            editable={false}
                            height='450px'
                            highlightActiveLine={false}
                            lightTheme='githubLight'
                            darkTheme='dracula'
                        />

                        {channelType === "IFRAME" && isNew === false && (
                            <div
                                className='iframe-chat-example'
                            >
                                <h2 className='h2-title'>Chat window</h2>
                                <iframe
                                    src={embeddingUrl}
                                    style={{width: '100%', height: '788px', border: 'none', borderRadius: '16px'}}
                                    allow="microphone; camera"
                                ></iframe>
                            </div>
                        )}

                    </div>
                )}
            </div>
        </div>
    )
}

function Channel({canEdit}) {
    return (
        <AlertProvider>
            <ConfirmationProvider>
                <ChannelApiProvider>
                    <MetaApiProvider>
                        <ChannelContent canEdit={canEdit}/>
                    </MetaApiProvider>
                </ChannelApiProvider>
            </ConfirmationProvider>
        </AlertProvider>
    );
}

export default Channel;